import { cursorPaginationFieldPolicy } from '../../../../utils/policies';
import type { TypePolicies } from '../../../../utils/types/TypePolicies';

export const typePolicies: TypePolicies = {
  Share: {
    fields: {
      activities: cursorPaginationFieldPolicy(['page', ['first']]),
    },
  },
};
